/* @ngInject */
function UserVerificationController (
  $scope,
  $timeout,
  $location,
  $translate,
  $sce,
  $stateParams,
  $state,
  $window,
  AuthService,
  CONSTANTS,
  UserService,
  MessageService,
  ToastService,
  Utils
) {
  const sHost = $location.host()
  $scope.subdomain = ''
  $scope.customerLogoPath = ''
  $scope.backgroundUrl = ''
  $scope.backgroundImageUrl = ''
  $scope.securityCodeField = {
    value: $stateParams.securityCode || '',
    error: false,
    errorMessage: ''
  }
  $scope.flags = {
    loadingLogo: true,
    loadingBackground: true,
    loadingData: true,
    loadingBtn: false
  }
  let emailSecretToken = null

  const api = { activate }

  this.getApi = () => api

  activate()

  function activate () {
    AuthService.setContainerPosition()
    emailSecretToken = $stateParams.emailSecretToken

    AuthService.getCustomerImages(sHost)
      .then(url => {
        $scope.customerLogoPath = url.logo
        $scope.backgroundUrl = url.background
        $scope.subdomain = localStorage.getItem('companySubdomain')
      })

    UserService.getUserByVerificationToken(emailSecretToken)
      .then((data) => {
        $scope.screenText = $sce.trustAsHtml($translate.instant('2FactorAuth.description', { email: data.email }))
        $scope.flags.loadingData = false

        if ($scope.securityCodeField.value) {
          $scope.submitSecurityCode()
        }
      })
      .catch((err) => {
        console.log(err)
        $state.go('login')
      })
  }

  $scope.onEmailChange = function (evt) {
    $scope.securityCodeField.value = evt.detail.value
  }

  $scope.submitSecurityCode = function () {
    $scope.securityCodeField.error = !$scope.securityCodeField.value

    if (!$scope.securityCodeField.value) {
      return
    }

    $scope.securityCodeField.errorMessage = ''
    $scope.flags.loadingBtn = true
    const verificationToken = emailSecretToken
    const securityCode = $scope.securityCodeField.value

    return UserService.verifySSOUser(verificationToken, securityCode)
      .then((userData) => {
        const url = Utils.fnAddQueryToUrl(CONSTANTS.URL_AUTH_SSO_LOGIN, {
          email: userData.email,
          subdomain: $scope.subdomain
        })

        $window.open(url, '_self')
      }).catch(() => {
        $scope.securityCodeField.error = true
        $scope.securityCodeField.errorMessage = $translate.instant('2FactorAuth.invalidCode')
        $scope.flags.loadingBtn = false
      })
  }

  $scope.resendSecurityCode = function () {
    const verificationToken = emailSecretToken

    return UserService.resendUserVerificationEmail(verificationToken)
      .then((data) => {
        emailSecretToken = data.emailSecretToken
        $location.search({
          emailSecretToken
        })

        ToastService.showSuccessToast($translate.instant('emailSent'))
      })
      .catch((err) => {
        if (err?.status === 429) {
          MessageService.warning({
            title: 'warning',
            text: '2FactorAuth.emailAlreadySent'
          })

          return
        }

        ToastService.defaultErrorToast()
      })
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onBackgroundLoad = function () {
    $timeout(() => {
      $scope.backgroundImageUrl = $scope.backgroundUrl
      $scope.flags.loadingBackground = false
    })
  }
}

export { UserVerificationController }
